import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormulaConfigProvider } from '@clean-code/feature/formula-builder/api-formula-builder';
import {
  BenchmarkComponentTypes,
  BenchmarkMethodeComponent,
  CustomDatSourceType,
  CustomDataSourceComponent,
  CustomMethodeComponent,
  CustomMethodeComponentTypes,
  MAMethodeComponent,
  MAMethodeComponentTypes,
  MarketToMarketComponentTypes,
  MarketToMarketMethodeComponent,
} from '@clean-code/feature/formula-builder/ui-methods';
import {
  FeatureTimeSeriesAnalysisIdentifierDatSourceConfigComponent,
  FeatureTimeSeriesAnalysisIdentifierDatSourceConfigComponentTypes,
} from '@clean-code/time-series-identifier/feature-feature-time-series-analysis-identifier-config';

@NgModule({
  imports: [CommonModule],
})
export class FormulaModule {
  constructor(configProvider: FormulaConfigProvider) {
    void configProvider.add(
      CustomDatSourceType.ConfigType,
      CustomDataSourceComponent
    );

    void configProvider.add(
      FeatureTimeSeriesAnalysisIdentifierDatSourceConfigComponentTypes.ConfigType,
      FeatureTimeSeriesAnalysisIdentifierDatSourceConfigComponent
    );

    void configProvider.addMethod(
      CustomMethodeComponentTypes.MethodeType,
      CustomMethodeComponent
    );
    void configProvider.addMethod(
      MAMethodeComponentTypes.MethodeType,
      MAMethodeComponent
    );

    void configProvider.addMethod(
      BenchmarkComponentTypes.MethodeType,
      BenchmarkMethodeComponent
    );

    void configProvider.addMethod(
      MarketToMarketComponentTypes.MethodeType,
      MarketToMarketMethodeComponent
    );
  }
}
